import React from 'react';
import { Box, Typography } from '@mui/material';

const SectionEyebrow = ({ children, color = 'primary.main', textColor = 'text.secondary' }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 2 }}>
    <Box sx={{ width: 4, height: 20, borderRadius: 1, bgcolor: color, flexShrink: 0 }} />
    <Typography
      sx={{
        fontWeight: 700,
        letterSpacing: 0.4,
        fontSize: { xs: 12.5, md: 13.5 },
        textTransform: 'uppercase',
        color: textColor,
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default SectionEyebrow;
